// removed by extract-text-webpack-plugin
module.exports = {"input":"DatePicker2__input___3IsDI","error":"DatePicker2__error___2ez9f","inputFeedback":"DatePicker2__inputFeedback___3bSHY"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/project/edit/components/DatePicker2.scss
// module id = 1693
// module chunks = 0